<script>
export default {
  name: "Warnings",
  props: {
    warningType: {
      type: String,
      required: true,
    },

    setDescription: {
      type: String,
      required: true,
      default: null,
    },

    closeButton: {
      type: Boolean,
      default: true,
    },

    fontSize: String,
    margin: String,
  },
};
</script>


<template>
  <Transition>
    <div
      v-if="setDescription || $slots.description"
      :style="{ fontSize: fontSize, margin: margin }"
      class="alertBox rotateX"
      :class="warningType"
    >
      <svg width="24" height="24">
        <path
          :fill="[
            warningType === 'error'
              ? 'var(--alert-error-color)'
              : warningType === 'success'
              ? 'var(--alert-success-color)'
              : warningType === 'warning'
              ? 'var(--alert-warning-color)'
              : warningType === 'info'
              ? 'var(--alert-info-color)'
              : '',
          ]"
          d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.31 7.526c-.099-.807.528-1.526 1.348-1.526.771 0 1.377.676 1.28 1.451l-.757 6.053c-.035.283-.276.496-.561.496s-.526-.213-.562-.496l-.748-5.978zm1.31 10.724c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
        />
      </svg>
      {{ setDescription }}
      <slot name="description"></slot>
      <span
        v-if="closeButton"
        class="closeButton"
        @click="$emit('closeWarning')"
      >
        <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
          <path
            :fill="[
              warningType === 'error'
                ? 'var(--alert-error-color)'
                : warningType === 'success'
                ? 'var(--alert-success-color)'
                : warningType === 'warning'
                ? 'var(--alert-warning-color)'
                : warningType === 'info'
                ? 'var(--alert-info-color)'
                : '',
            ]"
            d="M64,0a64,64,0,1,0,64,64A64.07,64.07,0,0,0,64,0Zm0,122a58,58,0,1,1,58-58A58.07,58.07,0,0,1,64,122Z"
          />
          <path
            :fill="[
              warningType === 'error'
                ? 'var(--alert-error-color)'
                : warningType === 'success'
                ? 'var(--alert-success-color)'
                : warningType === 'warning'
                ? 'var(--alert-warning-color)'
                : warningType === 'info'
                ? 'var(--alert-info-color)'
                : '',
            ]"
            d="M92.12,35.79a3,3,0,0,0-4.24,0L64,59.75l-23.87-24A3,3,0,0,0,35.88,40L59.76,64,35.88,88a3,3,0,0,0,4.25,4.24L64,68.25l23.88,24A3,3,0,0,0,92.13,88L68.24,64,92.13,40A3,3,0,0,0,92.12,35.79Z"
          />
        </svg>
      </span>
    </div>
  </Transition>
</template>

<style scoped>
.alertBox {
  position: relative;
  width: 100%;
  display: flex;
  background-color: var(--grey-1);
  border: 1px solid var(--grey);
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0px 0.5rem;
  user-select: none;
}

svg {
  margin: 2px 10px 0px 0px;
  min-width: 24px;
}

.alertBox.error {
  background-color: var(--alert-error-background);
  color: var(--alert-error-color);
  border: 1px solid var(--alert-error-border);
}

.alertBox.success {
  background-color: var(--alert-success-background);
  color: var(--alert-success-color);
  border: 1px solid var(--alert-success-border);
}

.alertBox.warning {
  background-color: var(--alert-warning-background);
  color: var(--alert-warning-color);
  border: 1px solid var(--alert-warning-border);
}

.alertBox.info {
  background-color: var(--alert-info-background);
  color: var(--alert-info-color);
  border: 1px solid var(--alert-info-border);
}

.closeButton {
  margin: 0px;
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-left: auto;
  cursor: pointer;
}

.closeButton:hover {
  opacity: 0.6;
}

.closeButton svg {
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
}

@media screen and (max-width: 995px) {
  .alertBox {
    font-size: 14px;
  }
}
</style>